import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupCategory() {
    const navigate = useNavigate();
    const [femaleCategory, setFemaleCategory] = useState("");

    const handleCategorySubmit = async () => {
      if (!femaleCategory) {
        toast.warn("Please select a category");
        return;
      }
    
      try {
        const res = await axios.post(
          `${API_URL}/reg-signup-category-update-api`,
          { female_category: femaleCategory },
          { withCredentials: true }
        );
    
        if (res.data.Status === "Success") {
          navigate(res.data.redirect);
        } else {
          toast.error("Failed to update Category.");
        }
      } catch (error) {
        console.error("Category update failed:", error);
        toast.error("Something went wrong.");
      }
    };

    
    return (
     
      
      <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="row g-3 w-100" style={{ maxWidth: "600px" }}>
        <div className="col-12">
          <div className="card bg-secondary text-white">
            <div className="card-body">
              <p className="h4 text-center">Select your category here</p>
    
              <div className="row g-3 align-items-end">
                <div className="col-12">
                  <ToastContainer />
    
                  <div className="form-check">
                    <input
                      type="radio"
                      name="female_category"
                      className="form-check-input checkbox_color"
                      value="Married"
                      checked={femaleCategory === "Married"}
                      onChange={(e) => setFemaleCategory(e.target.value)}
                    />
                    <label className="form-check-label">Married</label>
                  </div>
    
                  <div className="form-check">
                    <input
                      type="radio"
                      name="female_category"
                      className="form-check-input checkbox_color"
                      value="Single"
                      checked={femaleCategory === "Single"}
                      onChange={(e) => setFemaleCategory(e.target.value)}
                    />
                    <label className="form-check-label">Single</label>
                  </div>
    
                  <div className="form-check">
                    <input
                      type="radio"
                      name="female_category"
                      className="form-check-input checkbox_color"
                      value="Single-Mother"
                      checked={femaleCategory === "Single-Mother"}
                      onChange={(e) => setFemaleCategory(e.target.value)}
                    />
                    <label className="form-check-label">Single-Mother</label>
                  </div>
                </div>
    
                <div className="col-12 mb-3">
                  <div className="d-flex justify-content-between">
                    <button
                      onClick={handleCategorySubmit}
                      className="btn btn-primary"
                      type="submit"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>


    );
}

export default SignupCategory;
